import React from "react";

const BurgerIcon = ({ open, ...props }) => (
  <div className={open ? "burger-menu open" : "burger-menu"} {...props}>
    <div className="bar1" />
    <div className="bar2" />
    <div className="bar3" />
  </div>
);

export default BurgerIcon;
